module.exports = __webpack_public_path__ + "public/SiteImages/playStore.png?20e27bff";